import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ShopifySelectBadge.module.css';

export const SHOPIFY_SELECT_DIRECTORY =
  'https://www.shopify.com/partners/directory/partner/jamak-innovacion-digital1';

const SRC = {
  black: '/images/badges/shopify-select-partner-black.svg',
  white: '/images/badges/shopify-select-partner-white.svg',
};

/**
 * Official Shopify Select Partner mark.
 * Official SVG bytes live in public/images/badges/ — do not replace
 * with a custom bag mark. Black on light surfaces; white on inverse.
 */
const ShopifySelectBadge = ({
  variant = 'black',
  size = 'md',
  className = '',
}) => {
  const { t } = useTranslation('common');
  const src = SRC[variant] ?? SRC.black;
  const alt = t('shopifySelect.alt');
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <a
      href={SHOPIFY_SELECT_DIRECTORY}
      target="_blank"
      rel="noopener noreferrer"
      className={`${styles.badge} ${styles[size] ?? ''} ${className}`.trim()}
    >
      {imgFailed ? (
        <span className={styles.fallback}>{alt}</span>
      ) : (
        <img src={src} alt={alt} onError={() => setImgFailed(true)} />
      )}
    </a>
  );
};

export default ShopifySelectBadge;
